<template>
    <div class="slots-history" v-show="this.wins.length || true">
		<div class="slots-history__head">
			<div class="slots-history__title">Live выигрыши</div>
			<slot name="btn"></slot>
		</div>
        <div class="slots-history__items no-scrollbar" data-scroll-lock-scrollable>
            <transition-group name="list">
                <router-link
                    tag="div"
                    :to="{name: 'slotsGame', params: { gameId: win.game_id }}"
                    class="slots-history__item"
                    v-for="win in this.wins" :key="win.id">
                    <div class="slots-history__item-banner">
                        <img class="slots-history__item-img" :src="win.image" alt="">
                    </div>
                    <div class="slots-history__item-body">
						<div class="slots-history__item-tags">
							<span class="slots-history__item-tag slots-history__item-tag--success">{{ win.amount }} ₽</span>
							<span class="slots-history__item-tag" v-if="win.multiply > 3">x{{ win.multiply }}</span>
							<span class="slots-history__item-tag slots-history__item-tag--blue" v-if="typeof win.multiply === 'string'">{{ win.multiply }}</span>
						</div>
                        <div class="slots-history__item-title">{{ win.game_name_short }}</div>
                    </div>
                </router-link>
            </transition-group>
		</div>
    </div>
</template>

<script>
    import FadeTransition from "../Transitions/FadeTransition.vue";

    export default {
        components: {
            FadeTransition,
        },
        data() {
            return {
                tableLength: 10,
                firstRun: true,
                wins: []
            }
        },
		mounted() {
			this.fillTable();
		},

		methods: {
            fillTable() {
                this.$socket.emit('slotHistory', (data) => {
                    this.wins = data.wins.slice(0, this.tableLength);
                });
            }
        },
        sockets: {
            slotWin(win) {
                if (this.wins.length >= this.tableLength) {
                    this.wins.pop();
                }

                this.wins.unshift(win);
            }
        }
    }
</script>